import { StrictMode, useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@site-factory/theme";
import { ToastProvider } from "@site-factory/ui";
import { siteConfig } from "./site.config";
import App from "./App";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <AppWithTheme />
    </BrowserRouter>
  </StrictMode>
);

function AppWithTheme() {
  const [mode, setMode] = useState<"light" | "dark">(() => {
    const stored = typeof window !== "undefined" ? localStorage.getItem("sf-theme-mode") : null;
    return stored === "dark" ? "dark" : "light";
  });

  useEffect(() => {
    document.documentElement.dataset.theme = mode;
    localStorage.setItem("sf-theme-mode", mode);
  }, [mode]);

  useEffect(() => {
    const handleStorage = (e: StorageEvent) => {
      if (e.key === "sf-theme-mode" && (e.newValue === "light" || e.newValue === "dark")) {
        setMode(e.newValue);
      }
    };
    const handleCustom = (e: Event) => {
      const detail = (e as CustomEvent).detail;
      if (detail === "light" || detail === "dark") {
        setMode(detail);
      }
    };
    window.addEventListener("storage", handleStorage);
    window.addEventListener("sf-theme-change", handleCustom as EventListener);
    return () => {
      window.removeEventListener("storage", handleStorage);
      window.removeEventListener("sf-theme-change", handleCustom as EventListener);
    };
  }, []);

  return (
    <ThemeProvider theme={siteConfig.theme} mode={mode} onModeChange={setMode} persist>
      <ToastProvider />
      <App />
    </ThemeProvider>
  );
}
